import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
// CSS for tom-select is served separately via Propshaft (see
// vendor/assets/stylesheets/tom-select.css and the stylesheet_link_tag
// in the layout). Don't import it here — esbuild's CSS-from-JS handling
// is unreliable with our build setup, and Tailwind v4's --minify would
// purge JS-injected selectors anyway.

export default class extends Controller {
  static values = {
    url: String,
    valueField: { type: String, default: "id" },
    labelField: { type: String, default: "name" },
    searchField: { type: Array, default: ["name"] }
  }

  connect() {
    const config = {
      valueField: this.valueFieldValue,
      labelField: this.labelFieldValue,
      searchField: this.searchFieldValue,
      create: false
    }

    if (this.hasUrlValue) {
      config.load = (query, callback) => {
        const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
        fetch(url, { headers: { Accept: "application/json" } })
          .then(r => r.json())
          .then(callback)
          .catch(() => callback())
      }
    }

    this.instance = new TomSelect(this.element, config)

    // A morph refresh (the desk's live refresh as a Key Data run lands) would reset the select to
    // the server's bare markup and remove Tom Select's wrapper, leaving a
    // plain select behind a controller that never reconnects. Turbo asks
    // before it morphs or removes each element, so both are kept as they
    // are; a normal visit still renders the select afresh.
    this.keepThroughMorph = (event) => {
      if (event.target === this.element || event.target === this.instance?.wrapper) event.preventDefault()
    }
    document.addEventListener("turbo:before-morph-element", this.keepThroughMorph)
  }

  disconnect() {
    document.removeEventListener("turbo:before-morph-element", this.keepThroughMorph)
    this.instance?.destroy()
  }
}
